import React, { useEffect } from "react";
import styled, { useTheme } from "styled-components";
import { Alert, Box, Button, Grid, Icon, Link, Text } from "~/components-shared";
import { AIQueryRoleEnum, StatusStateEnum } from "~/types/enums";
import Markdown from "~/components/Markdown";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import aiQuerySelectors from "~/store/aiQueries/selectors";
import aiQueriesActionCreators from "~/store/aiQueries/actions";
import moment from "moment/moment";
import StyledIcon from "~/components/StyledIcon";
const Wrapper = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
  height: calc(80vh - 180px);
  padding: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.spacing.step * 6;
}}px ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing.step * 6;
}}px 0
    ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing.step * 6;
}}px;
`;
const MessageList = styled.div`
  flex-grow: 1;
  overflow: auto;
  display: flex;
  flex-direction: column-reverse;
  padding-right: 0.75em;
  margin-right: -0.75em;
  width: 100%;
`;
const Message = styled.div`
  border-radius: 1rem;
  background-color: ${_ref4 => {
  let {
    theme,
    isPrimary
  } = _ref4;
  return isPrimary ? theme.colors.primary.main : theme.colors.grey.main;
}};
  color: ${_ref5 => {
  let {
    theme,
    isPrimary
  } = _ref5;
  return isPrimary ? theme.colors.background.primary : theme.colors.text.primary;
}};
  padding: 0.75em 1em;
`;
const AiAssistantChat = _ref6 => {
  let {
    onRequest
  } = _ref6;
  const theme = useTheme();
  const dispatch = useDispatch();
  const queries = useSelector(aiQuerySelectors.getAiQueries);
  const status = useSelector(aiQuerySelectors.getStatus);
  const {
    hasAfter
  } = useSelector(aiQuerySelectors.getPagination);
  const listError = useSelector(aiQuerySelectors.getError);
  const createError = useSelector(aiQuerySelectors.getErrorByQuery("+"));
  const error = createError || listError;
  const {
    t
  } = useTranslation();
  useEffect(() => {
    if (status === StatusStateEnum.IDLE) {
      dispatch(aiQueriesActionCreators.fetchStarted());
    }
  }, [status, dispatch]);
  const handleLoadMore = () => {
    dispatch(aiQueriesActionCreators.loadedMore());
  };
  return /*#__PURE__*/React.createElement(Wrapper, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), queries.length ? /*#__PURE__*/React.createElement(MessageList, null, /*#__PURE__*/React.createElement(Grid, {
    cols: 1,
    gap: 3,
    fullWidth: true
  }, queries.sort((a, b) => moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf()).map(query => /*#__PURE__*/React.createElement(Grid.Cell, {
    key: query.id,
    justify: query.role === AIQueryRoleEnum.USER ? "end" : "start"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    display: "block",
    s: {
      mb: 1,
      mx: 3
    },
    align: query.role === AIQueryRoleEnum.USER ? "right" : "left"
  }, query.role === AIQueryRoleEnum.ASSISTANT && "Assistant", /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "light",
    s: {
      mx: 2
    }
  }, moment(query.createdAt).local().startOf("seconds").fromNow()), query.role === AIQueryRoleEnum.USER && "You"), /*#__PURE__*/React.createElement(Message, {
    isPrimary: query.role === AIQueryRoleEnum.USER
  }, /*#__PURE__*/React.createElement(Markdown, {
    fontSize: 4,
    lineHeight: 6,
    display: "block",
    text: query.text,
    components: {
      a: _ref7 => {
        let {
          href = "",
          children
        } = _ref7;
        return /*#__PURE__*/React.createElement(Link, {
          href: href,
          color: theme.colors.text.primary,
          underline: true
        }, children.join(""));
      }
    }
  }))))), hasAfter && /*#__PURE__*/React.createElement(Button, {
    onClick: handleLoadMore,
    loading: status === StatusStateEnum.LOADING,
    color: "transparent",
    s: {
      mb: 5
    }
  }, "Load more")) : /*#__PURE__*/React.createElement(Box, {
    justify: "center",
    align: "center",
    fullWidth: true,
    style: {
      flexGrow: 1
    }
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "column",
    align: "center"
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    src: "sparkles"
  }), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    weight: "semiBold",
    display: "block",
    s: {
      mt: 6
    }
  }, t("AiAssistantChat.noHistory")), /*#__PURE__*/React.createElement(Markdown, {
    color: "textSecondary",
    fontSize: 4,
    display: "block",
    s: {
      mt: 3,
      mb: 5
    },
    lineHeight: 6,
    style: {
      maxWidth: "500px"
    },
    align: "center",
    text: t("AiAssistantChat.noHistoryInfo")
  }), /*#__PURE__*/React.createElement(Button, {
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      src: "chat",
      s: {
        mr: 2
      }
    }),
    onClick: () => onRequest(t("AiAssistantChat.example")),
    s: {
      mb: 3
    }
  }, t("AiAssistantChat.example")))));
};
export default AiAssistantChat;